import { render } from "./withAuthLayout.vue?vue&type=template&id=65d15ee5"
import script from "./withAuthLayout.vue?vue&type=script&lang=js"
export * from "./withAuthLayout.vue?vue&type=script&lang=js"
script.render = render

export default script